module.exports = __webpack_public_path__ + "img/H1_Boutique.66f6fb08.png";